import React, {useState} from 'react';
import {Button as AntdButton, Modal } from 'antd';
import { useHistory} from 'react-router-dom';
import {
  SinglePageHeader,
  FooterWithoutAuth,
  Button,
  AdVideo,
  Layout,
} from 'components';
import { Swiper, SwiperSlide } from 'swiper/react';

import './main-page.less';
import homeBanner from '../../assests/images/home-banner.png';

import homeBanner2 from '../../assests/images/home-banner-2.png';
import kolayKullanim from '../../assests/images/kolay-kullanim.png';
import hizliAbonelik from '../../assests/images/hizli-abonelik.png';
import topluMms from '../../assests/images/home-toplu-mms.png';
import topluSms from '../../assests/images/home-toplu-sms.png';
import bannerAccessory1 from '../../assests/images/banner-accessory-1.png';
import bannerAccessory2 from '../../assests/images/banner-accessory-2.png';
import bannerAccessory3 from '../../assests/images/banner-accessory-3.png';
import featuresAccessory1 from '../../assests/images/features-accessory-1.png';
import featuresAccessory2 from '../../assests/images/features-accessory-2.png';
import featuresAccessory3 from '../../assests/images/features-accessory-3.png';
import featuresAccessory4 from '../../assests/images/features-accessory-4.png';
import featuresAccessory5 from '../../assests/images/features-accessory-5.png';
import featuresAccessory6 from '../../assests/images/features-accessory-6.png';
import featuresAccessory7 from '../../assests/images/features-accessory-7.png';
import featuresAccessory8 from '../../assests/images/features-accessory-8.png';
import featuresAccessory9 from '../../assests/images/features-accessory-9.png';
import featuresAccessory10 from '../../assests/images/features-accessory-10.png';
import RightChevronIcon from '../../assests/icons/right-chevron.icon';
import { LANDING_MENU } from 'constants/page.const';
import { MetaTags } from 'react-meta-tags';
import { hemenBaslaEvent} from 'utils/fb-pixel-code-event';

const MainPage = () => {
  let history = useHistory();

  const [modalInfo, setModalInfo] = useState(false);

  return (
    <Layout
      hamburgerMenuWithButton={true}
      hamburgerMenuData={LANDING_MENU}
      hamburgerMenuClass="single-page-v1"
      withoutHeaderDropdown={true}
      withoutCreditInfo={true}
      menuSinglePageV2={true}
      customMenuRender={() => <SinglePageHeader />}
      whiteLogo={true}
    >
      <MetaTags>
        <title>Mesaj Üssü: Toplu SMS ve ZİM - Kurumsal SMS - Mesaj Paneli</title>
        <meta name="description" content="Turkcell Mesaj Üssü ile SMS paneli üzerinden toplu SMS ve ZİM gönderebilirsiniz. Hızlıca toplu mesajlaşma servisini kullanmaya başlayabilirsiniz." />
        <link rel="canonical" href="https://mesajussu.turkcell.com.tr"></link>
      </MetaTags>
      <div className="how-it-works-page">
        <section className="single-page-banner">
          <div className="container">
            <Swiper
              spaceBetween={20}
              slidesPerView="1"
              loop={true}
              navigation={{
                nextEl: '#swiper-banner-next',
                prevEl: '#swiper-banner-prev'
              }}
              pagination={{
                clickable: true,
                el: '#swiper-banner-pagination'
              }}
            >
              <SwiperSlide>
                <div>
                  <h1 className="section__title--big">
                    <AdVideo >Satışlarınızı Arttırmanın En Akıllı Yolu</AdVideo>
                  </h1>
                  <p className="info-text--big">
                    Toplu SMS ve Zengin İçerikli Mesaj göndermek için Turkcell
                    telefon numaranızla giriş yapmanız yeterli.
                  </p>
                  <Button type="primary" 
                    shape="round" 
                    onClick={() =>{
                    hemenBaslaEvent();
                    history.push('/Login'); }}
                    >
                    Hemen Başla
                  </Button>
                </div>
                <AdVideo >
                <figure>
                    <img src={homeBanner} alt="Satışlarınızı Arttırmanın En Akıllı Yolu" />
                </figure>
                </AdVideo>
              </SwiperSlide>
              <SwiperSlide>
                <div>
                  <h1 className="section__title--big">
                    <AdVideo>
                      Müşterilerinize sesinizi duyurun!
                    </AdVideo>
                  </h1>
                  <p className="info-text--big">
                    Firma adınızla reklam, kampanya ve bilgilendirme mesajlarınızı göndererek müşterilerinize ulaşabilirsiniz.
                  </p>
                  <Button type="primary" 
                  shape="round" 
                  onClick={()=>{
                    hemenBaslaEvent();
                    history.push('/Login');
                  }}>
                    Hemen Başla
                  </Button>
                </div>
                <AdVideo >
                <figure>
                    <img src={homeBanner2} alt="Müşterilerinize sesinizi duyurun!" />
                </figure>
                </AdVideo>

              </SwiperSlide>
            </Swiper>
            <div className="swiper-accessories">
              <div id='swiper-banner-prev'><RightChevronIcon /></div>
              <div id='swiper-banner-pagination'></div>
              <div id='swiper-banner-next'><RightChevronIcon /></div>
            </div>
          </div>
          <img id="banner-accessory-3" src={bannerAccessory3} alt='Accessory Image' />
        </section>
        <article>
          <div className="container">
            <section className="single-page-features">
              <figure>
                <img src={hizliAbonelik} alt="Hızlı Abonelik" />
              </figure>
              <div>
                <h1 className="section__title--big">Hızlı Abonelik</h1>
                <p className="info-text--big">Kağıt evrak veya imza süreci olmadan kolayca üye olabilirsiniz. Üstelik üye olduğunuz anda 50 SMS hediye!
                  Şirket evraklarınızı online olarak yükleyin ve mesaj başlığınızı anında belirleyin, aynı gün içinde mesaj göndermeye başlayın.</p>
              </div>
              <img id="features-accessory-1" src={featuresAccessory1} alt="Accessory Image" />
              <img id="features-accessory-2" src={featuresAccessory2} alt="Accessory Image" />
            </section>
            <section className="single-page-features">
              <figure>
                <img src={kolayKullanim} alt="Kolay Kullanım" />
              </figure>
              <div>
                <h1 className="section__title--big">Kolay Kullanım</h1>
                <p className="info-text--big">Toplu mesaj gönderme sistemindeki mükemmel kullanıcı deneyimiyle SMS ve Zengin İçerikli Mesajlarınızı (MMS) kolayca hazırlayın ve gönderin.
                  Mesaj Üssü, SMS paneli sizi adım adım yönlendirirken size sadece oluşturacağınız toplu mesajın içeriğini düşünmek kalsın.
                  Ayrıca Turkcell Mesaj Üssü farkı ile gönderim sonuçlarınızı analiz edebilirsiniz.</p>
                <Button type="primary" shape="round" href="/nasil-calisir">
                  Devam
                </Button>
              </div>
              <img id="features-accessory-3" src={featuresAccessory3} alt="Accessory Image" />
            </section>
            <section className="single-page-features">
              <figure>
                <img src={topluSms} alt="Toplu SMS Sistemi" />
              </figure>
              <div>
                <h1 className="section__title--big">Toplu SMS Sistemi</h1>
                <p className="info-text--big">Mesaj paneli üzerinden toplu SMS gönderimlerinizi hızlı ve kolay bir şekilde yapın. Özel gün kutlama, kampanya duyurma ve yeni hizmet duyurusu gibi iletişim çalışmalarınızı Turkcell Mesaj Üssü ile toplu mesaj göndererek hedef kitlenizle iletişime geçin! </p>
                <Button type="primary" shape="round" href="/toplu-sms">
                  Devam
                </Button>
                <img id="features-accessory-5" src={featuresAccessory5} alt="Accessory Image" />
              </div>
              <img id="features-accessory-4" src={featuresAccessory4} alt="Accessory Image" />
              <img id="features-accessory-6" src={featuresAccessory6} alt="Accessory Image" />
            </section>
            <section className="single-page-features">
              <figure> <img src={topluMms} alt="Zengin İçerikli Mesaj (ZİM)" />

              </figure>
              <div>
                <h1 className="section__title--big">Zengin İçerikli Mesaj (ZİM)</h1>
                <p className="info-text--big">Hedef kitlenize toplu ZİM (Zengin İçerikli Mesaj) gönderin, mesajlarınız daha çok okunsun!
                  Mesajınızı görsellerle,
                  videolarla ve dosyalarla zenginleştirerek toplu MMS formatında gönderin, görselin gücünü kullanarak fark yaratın.</p>
                <Button type="primary" shape="round" href="/toplu-mms-zim">
                  Devam
                </Button>
              </div>
              <img id="features-accessory-7" src={featuresAccessory7} alt="Accessory Image" />
              <img id="features-accessory-8" src={featuresAccessory8} alt="Accessory Image" />
            </section>
            <section>
              <div>
              </div>
            </section>
          </div>
        </article>
        <section className="information-count">
          <div className="container">
            <div>
              <img id="features-accessory-10" src={featuresAccessory10} alt="Accessory Image" />
              <h2 className="section__title">
                Mesaj Üssü'ne üye olun, müşterilerinizle hızla iletişime geçin.
              </h2>
            </div>
            <Button type="primary" shape="round" href="/Login">
              Hemen Başla
            </Button>
          </div>
        </section>
      </div>
      <Modal
        title="Önemli Bilgilendirme"
        visible={modalInfo}
        className='info-modal'
        onCancel={() => setModalInfo(false)}
        footer={
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyItems: 'center',
            }}
          >
            <Button
              type="primary"
              onClick={() =>
                window.open(
                  'https://anindamobilimza.turkcell.com.tr/mobilimza',
                  '_blank'
                )
              }
            >
              Mobil İmza Al
            </Button>
            <Button
              style={{ marginTop: '8px', marginLeft: '0' }}
              type="default"
              onClick={() => setModalInfo(false)}
            >
              Anladım
            </Button>
          </div>
        }
      >
        <div style={{ textAlign: 'justify', paddingRight: '2px' }}>
          <p>
            Bilgi Teknolojileri ve İletişim Kurulu'nun{' '}
            <strong>16.12.2025</strong> tarih ve{' '}
            <strong>2025/DK-YED/399</strong> sayılı kararı kapsamında SMS ve MMS
            gibi mesaj gönderim kullanıcı arayüzlerinin giriş ekranlarına
            göndericinin veya SMS ve MMS göndermeye yetkili kişinin güvenli
            elektronik imza ile giriş yaparak kullanması{' '}
            <strong>1 Nisan 2026</strong> itibarıyla zorunlu tutulmuştur.
          </p>
          <p>
            Mesaj Üssü'nde güvenli elektronik imza ile giriş için ilk aşamada{' '}
            <strong>Turkcell Mobil İmza</strong> ile giriş desteği sunulacaktır.
            Diğer güvenli elektronik imza oluşturma araçlarının entegrasyonu
            ilerleyen dönemde sağlanacaktır.
          </p>
          <p style={{ marginBottom: '0' }}>
            Mesaj Üssü kullanımınızın kesintiye uğramaması için{' '}
            <strong>1 Nisan 2026</strong> tarihine kadar Turkcell Mobil İmza
            alabilirsiniz.
          </p>
        </div>
      </Modal>
      <FooterWithoutAuth />
    </Layout>
  );
};

export default MainPage;
